export function notificationGet() {
	return {
    type: 'NOTIFICATION_GET',
	}
};

export function notificationInit() {
	return {
    type: 'NOTIFICATION_INIT',
	}
};
